import type { OasDocument3XExtended, OasTableExtension } from '@ipfabric/utils';
import { getOasOperationTable } from 'utils/oas/getOasOperationTable';

export const getXTableOas = (
  oas: OasDocument3XExtended,
  apiEndpoint: string,
): OasTableExtension | undefined =>
  getOasOperationTable(oas, apiEndpoint)?.['x-table'];
